import { BaseHttpTransport } from '@axmit/transport';
import axios, { AxiosInstance } from 'axios';

export const tagsTransport = new BaseHttpTransport<AxiosInstance, any>('tag', axios);
